import React from "react";

const Challenges = () => {
  return <div>Challenges</div>;
};

export default Challenges;
